import Vue from 'vue'
import { LanguageFolder } from 'beisheim/models'
import translations from 'beisheim/translations'

Vue.mixin({
  data () {
    return {
      $defaultLanguage: 'de',
      $defaultCountry: 'de'
    }
  },
  computed: {
    $currentLocale () {
      return LanguageFolder.query().where(r =>
        r.columns.language === this.$route.params.language &&
        r.columns.country === this.$route.params.country
      ).first()
    },
    $language () {
      if (!this.$currentLocale) { return this.$defaultLanguage }
      return this.$currentLocale.columns.language
    },
    $country () {
      if (!this.$currentLocale) { return this.$defaultCountry }
      return this.$currentLocale.columns.country
    }
  },
  methods: {
    $i18n (message, vars) {
      if (!message) {
        throw new Error('No message passed to i18n().')
      }

      if (vars && typeof vars !== 'object') {
        throw new Error('Second argument of i18n() must be an object.')
      }

      let translation

      if (this.$language) {
        translation = translations[this.$language][message]
      } else {
        translation = translations[this.$defaultLanguage][message]
      }

      if (!translation) {
        // eslint-disable-next-line no-console
        console.warn(`Translation for "${message}" not found.`)
        return message
      }

      if (vars) {
        Object.keys(vars).forEach((key) => {
          translation = message.replace(`{${key}}`, vars[key])
        })
      }

      return translation
    }
  }
})
